const LEGACY_EMPLOYEE_ID_PATTERN = /^[1-9]\d*$/u;
const STABLE_EMPLOYEE_ID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/iu;

export const normalizePayrollProfileRouteId = (
  value: string | undefined,
): string | null => {
  const candidate = value?.trim();
  return candidate &&
    (LEGACY_EMPLOYEE_ID_PATTERN.test(candidate) ||
      STABLE_EMPLOYEE_ID_PATTERN.test(candidate))
    ? candidate
    : null;
};

export const payrollProfileEmployeeMatchesRoute = (
  employeeId: string | number,
  routeId: string,
) => String(employeeId) === routeId;
